__turbopack_context__.v({
  "avatar": "FocusAreaDialog-module-scss-module__8IclTG__avatar",
  "avatars": "FocusAreaDialog-module-scss-module__8IclTG__avatars",
  "avatarsContainer": "FocusAreaDialog-module-scss-module__8IclTG__avatarsContainer",
  "description": "FocusAreaDialog-module-scss-module__8IclTG__description",
  "desktop": "FocusAreaDialog-module-scss-module__8IclTG__desktop",
  "footer": "FocusAreaDialog-module-scss-module__8IclTG__footer",
  "footerCount": "FocusAreaDialog-module-scss-module__8IclTG__footerCount",
  "footerRow": "FocusAreaDialog-module-scss-module__8IclTG__footerRow",
  "footerText": "FocusAreaDialog-module-scss-module__8IclTG__footerText",
  "headerSection": "FocusAreaDialog-module-scss-module__8IclTG__headerSection",
  "mobile": "FocusAreaDialog-module-scss-module__8IclTG__mobile",
  "mobileCount": "FocusAreaDialog-module-scss-module__8IclTG__mobileCount",
  "mobileCountText": "FocusAreaDialog-module-scss-module__8IclTG__mobileCountText",
  "mobileDescription": "FocusAreaDialog-module-scss-module__8IclTG__mobileDescription",
  "mobileFooter": "FocusAreaDialog-module-scss-module__8IclTG__mobileFooter",
  "mobileHeaderSection": "FocusAreaDialog-module-scss-module__8IclTG__mobileHeaderSection",
  "mobileProjectsSection": "FocusAreaDialog-module-scss-module__8IclTG__mobileProjectsSection",
  "mobileTeamsSection": "FocusAreaDialog-module-scss-module__8IclTG__mobileTeamsSection",
  "mobileTitle": "FocusAreaDialog-module-scss-module__8IclTG__mobileTitle",
  "title": "FocusAreaDialog-module-scss-module__8IclTG__title",
});
